import { Link } from "react-router-dom";
import { useTranslation } from "@/hooks/useTranslation";
import { useRouteLocale } from "@/hooks/useRouteLocale";
import { PUBLIC_ROUTES } from "@/routes/public";

const LINK_CLASS = "hover:text-foreground transition-colors";

/**
 * The "Legal" and "Support" footer columns shared by the landing page, the
 * customer dashboard and the public content pages.
 *
 * Every internal link keeps the locale of the current URL (JUB-100: on /en
 * pages the Cookie Policy link used to point at /ro). Terms, Privacy and
 * Contact have no published page yet and stay as "#".
 */
export function FooterLinkColumns() {
  const { t } = useTranslation();
  const locale = useRouteLocale();

  return (
    <>
      {/* Legal Links */}
      <div>
        <h4 className="font-semibold text-foreground mb-4">{t("footer.legal")}</h4>
        <ul className="space-y-2 text-sm text-muted-foreground">
          <li>
            <Link to={PUBLIC_ROUTES.terms(locale)} className={LINK_CLASS} data-testid="footer-link-terms">
              {t("footer.terms")}
            </Link>
          </li>
          <li>
            <Link to={PUBLIC_ROUTES.privacy(locale)} className={LINK_CLASS} data-testid="footer-link-privacy">
              {t("footer.privacy")}
            </Link>
          </li>
          <li>
            <Link to={PUBLIC_ROUTES.cookiesPolicy(locale)} className={LINK_CLASS} data-testid="footer-link-cookies">
              {t("footer.cookies")}
            </Link>
          </li>
          <li>
            <a
              href="https://reclamatiisal.anpc.ro"
              target="_blank"
              rel="noopener noreferrer"
              className={LINK_CLASS}
              data-testid="footer-link-anpc-sal"
            >
              {t("footer.anpcSal")}
            </a>
          </li>
        </ul>
      </div>

      {/* Support Links */}
      <div>
        <h4 className="font-semibold text-foreground mb-4">{t("footer.support")}</h4>
        <ul className="space-y-2 text-sm text-muted-foreground">
          <li>
            <Link to={PUBLIC_ROUTES.faq(locale)} className={LINK_CLASS} data-testid="footer-link-faq">
              {t("footer.faq")}
            </Link>
          </li>
          <li>
            <Link to={PUBLIC_ROUTES.blog(locale)} className={LINK_CLASS} data-testid="footer-link-blog">
              {t("footer.blog")}
            </Link>
          </li>
          <li>
            <a href="mailto:contact@wedistar.com" className={LINK_CLASS} data-testid="footer-link-contact">
              {t("footer.contact")}
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}
